import {Component, ErrorHandler, Input, OnInit, DoCheck} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AirportService} from '../airport.service';
import {Airport} from '../models/airport.model';
import {getEveryIntercardinalDirection} from '../../util/geodesy/helpers';
@Component({
  selector: 'app-distance-calculator',
  templateUrl: './distance-calculator.component.html',
  styleUrls: ['./distance-calculator.component.scss']
})
export class DistanceCalculatorComponent implements OnInit, DoCheck {
  @Input() airport: Airport;
  oldAirport: Airport;
  fromAirport: Airport;
  toAirport: Airport;
  direction: string;
  distance: number;
  showCalculation = false;
  showFromBlank = true;
  showToBlank = false;
  showFromProcessing = false;
  showToProcessing = false;

  constructor(private _airports: AirportService) {}

  ngOnInit() {
    this.oldAirport = this.airport;
    this.toAirport = this.airport;
  }

  ngDoCheck() {
  /* This hack is to handle routes coming from the autocomplete search.
    * Without it, an airport manager would look like they could manage airports they don't have permission to manage.
    * The API prevents any actual changes regardless of what the interface shows without this hack. */
    if (this.airport && this.oldAirport && this.airport.airportId !== this.oldAirport.airportId) {
      this.oldAirport = this.airport;
      this.toAirport = this.airport;
      this.reset();
      this.showToBlank = false;
    }
  }

  async calculateDistance() {
    this.showFromBlank = false;
    this.showToBlank = false;
    this.showCalculation = true;
    this.fromAirport = await this._airports.getAirport($('#DistanceFrom').val().toString(), true);
    this.toAirport = await this._airports.getAirport($('#DistanceTo').val().toString(), true);
    if (this.toAirport != null && this.fromAirport != null) {
      this.distance = Math.round(this.toAirport.location.distanceTo(this.fromAirport.location) / 1852 * 10) / 10;
      const dirResult = this.fromAirport.location.vincentyInverse(this.toAirport.location);
      this.direction = getEveryIntercardinalDirection(dirResult.initialBearing);
    }
  }

  async planFlightClick() {
    this.fromAirport = await this._airports.getAirport($('#DistanceFrom').val().toString(), true);
    this.toAirport = await this._airports.getAirport($('#DistanceTo').val().toString(), true);
    // allow empty inputs but not invalid airport ids
    const allAirportIdsValidOrBlank = ((this.toAirport != null || this.showToBlank) && (this.fromAirport != null || this.showFromBlank));
    if (allAirportIdsValidOrBlank) {
      const fromAirportId = this.fromAirport != null ? this.fromAirport.faaId : '';
      const toAirportId = this.toAirport != null ? this.toAirport.faaId : '';
      const url = `https://iflightplanner.aopa.org/My/Trip/?From=${fromAirportId}&To=${toAirportId}`;
      window.open(url, '_blank').focus();
    }
  }

  async onBlurFromIdent() {
    this.showFromProcessing = true;
    this.showFromBlank = false;
    this.showCalculation = false;
    this.fromAirport = await this._airports.getAirport($('#DistanceFrom').val().toString(), true);
    this.showFromProcessing = false;
  }

  async onBlurToIdent() {
    this.showToProcessing = true;
    this.showToBlank = false;
    this.showCalculation = false;
    this.toAirport = await this._airports.getAirport($('#DistanceTo').val().toString(), true);
    this.showToProcessing = false;
  }

  reset() {
    $('#DistanceFrom').val('');
    $('#DistanceTo').val(this.airport.identifier);
    this.showCalculation = false;
    this.showFromBlank = true;
    this.showToBlank = true;
  }
}

